import { Module, BootstrapOptions } from 'owa-bootstrap';
import * as React from 'react';
import { publishedCalendarModuleNameText } from './strings.locstring.json';
import { initializeIcons } from '@fluentui/react/lib/Icons';
import { getMailAriaTenantTokens, logUsage } from 'owa-analytics';
import { setupErrorHandler } from 'owa-exception-handler-devtools';
import loc from 'owa-localize';
import { parsePublishedFolderPath } from 'owa-publishedcalendar-settings';
import { initializeCalendarSurfaceOptions, PublishedCalendar } from 'owa-publishedcalendar-surface';
import { SessionData } from 'owa-service/lib/types/SessionData';
import { OwaWorkload } from 'owa-workloads';
import { BootStrategies } from 'owa-shared-start';

export function getPublishedCalendarBootstrapOptions(
    sessionPromise: Promise<SessionData | undefined>,
    strategies?: BootStrategies
): Promise<BootstrapOptions> {
    initializeIcons();

    const publishedFolderPath = parsePublishedFolderPath();
    logUsage('GetPublishedCalendarSessionData_Start', {
        isConsumer: publishedFolderPath.indexOf('@') == -1, // consumer calendar links don't include @domain
        isEdu: /\.edu(.|\/)/i.test(publishedFolderPath),
    });

    return Promise.resolve({
        initializeState: () => {
            initializeCalendarSurfaceOptions();
            setupErrorHandler();
        },
        analyticsOptions: {
            ariaTenantTokens: getMailAriaTenantTokens(),
        },
        sessionPromise,
        strategies,
        getModuleName: () => loc(publishedCalendarModuleNameText),
        workload: OwaWorkload.Calendar,
        shouldInitializeTimeZoneAnonymously: true,
        appModuleProps: {
            module: Module.PublishedCalendar,
            renderModule: () => <PublishedCalendar />,
        },
    });
}
